// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-navview',
    // #endregion
    // #region Props
    data: () => ({
        nodes: [],
        ancestor: [],
        component: {},
    }),
    // #endregion
    // #region Constructor
    created() {
        this.updateNode();
    },
    mounted() {
        //Data
        this.component = new bootstrap.Offcanvas(this.$refs['_MobileMenu']);
        //Events
        this.$refs['_MobileMenu'].addEventListener('hidden.bs.offcanvas', function () {
            if (appHost.pageMeta.mobileNavVisible) {
                appHost.pageMeta.mobileNavVisible = false;
            }
        });
    },
    // #endregion
    // #region Computed
    computed: {
        label() {
            // #region Check
            if (!this.ancestor) {
                return '';
            }
            if (this.ancestor.length == 0) {
                return '';
            }
            // #endregion
            return this.ancestor[this.ancestor.length - 1].caption;
        },
        isTop() {
            return this.ancestor && this.ancestor.length == 1;
        },
        mainMenu() {
            return this.$appHost.store.get('navigation').mainMenu;
        }
    },
    // #endregion
    // #region Watch
    watch: {
        '$appHost.pageMeta.mobileNavVisible': function (value) {
            if (value) {
                this.component.show();
            }
            else {
                this.component.hide();
            }
        },
        'mainMenu': function (value) {
            this.updateNode();
        },
    },
    // #endregion
    // #region Core
    methods: {
        updateNode() {
            //Reset
            this.ancestor = [];
            //Get
            let tDataSource = this.$appHost.store.getter('navigation/getMenu', 'MAIN');
            //Root
            let tMenuNode = {
                menuID: '.',
                caption: this.$t('client.Common.MainMenu'),
                children: tDataSource,
                index: 0,
                alignment: 0,
            };
            this.onMoveToItem(tMenuNode);
        },
        onToogle(event) {
            event.stopPropagation();
            this.$appHost.pageMeta.hideMobileNav();
        },
        hasChildren(node) {
            if (!utils.isNullOrEmpty(node.childType)) {
                return true;
            }
            else {
                return node.children && node.children.length > 0;
            }
        },
        async onMoveToItem(item) {
            // #region Check
            if (!item) {
                return;
            }
            // #endregion
            // #region Set
            //Children
            this.nodes = await this.getChildren(item);
            //ancestor
            this.ancestor.push(item);
            // #endregion
        },
        async onMoveBack() {
            // #region Check
            if (!this.ancestor) {
                return;
            }
            if (this.ancestor.length == 1) {
                return;
            }
            // #endregion
            // #region Set
            //Remove
            this.ancestor.pop();
            //Set
            this.nodes = await this.getChildren(this.ancestor[this.ancestor.length - 1]);
            // #endregion
        },
        async getChildren(node) {
            if (node.childType === 'MENU') {
                if (!node.childCommand) {
                    return [];
                }
                else {
                    return this.$appHost.store.getter("navigation/getMenu", node.childCommand);
                }
            }
            else if (node.childType === 'GENERIC') {
                return await this.$appHost.store.getter("navigation/getCachedMenu", node.menuID)?.children;
            }
            else {
                return node.children;
            }
        },
    },
    // #endregion
});
// #endregion
